import SearchIcon from "components/icons/SearchIcon";

type SearchInputProps = {
  value: string;
  placeHolder: string;
  onChange: (value: string) => void;
};

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  placeHolder,
  onChange,
}) => (
  <div className="flex h-[45px] w-full items-center justify-center rounded-xl border !border-gray-200 dark:!border-none dark:!bg-navy-700">
    <SearchIcon />
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      type="text"
      placeholder={placeHolder}
      className="!w-full rounded-xl text-sm font-medium outline-none dark:bg-navy-700 dark:text-white"
    />
  </div>
);
